const BaseComponent = require('base/base-component');

class univFooter extends BaseComponent{
  constructor() {
    super()
  }
  init(){
    const relevantDepartment = [
      {name:"资产管理处",url:"http://zcc.zufe.edu.cn/"},
      {name:"纪检监察",url:"http://jjs.zufe.edu.cn/"},
      {name:"审计处",url:"http://sjc.zufe.edu.cn/"},
      {name:"计划财务处",url:"http://cwc.zufe.edu.cn/"},
    ];
    const relevantSchool = [
      {name:"浙江大学采购网",url:"http://zupc.zju.edu.cn/cn20/"},
      {name:"浙江师范大学采购中心",url:"http://cgzx.zjnu.edu.cn/"},
      {name:"杭州电子科技大学采购中心",url:"http://cgzx.hdu.edu.cn/"},
      {name:"浙江工业大学采购中心",url:"http://www.cgzx.zjut.edu.cn/"},
    ];
    const otherLink = [
      {name:"中华人民共和国财政部",url:"http://www.mof.gov.cn/index.htm"},
      {name:"浙江省财政厅",url:"http://www.zjczt.gov.cn/"},
      {name:"中国政府采购网",url:"http://www.ccgp.gov.cn/"},
      {name:"浙江政府采购网",url:"http://zfcg.czt.zj.gov.cn/"},
      {name:"杭州政府采购网",url:"http://cg.hzft.gov.cn/"},

    ];
    const webArr = [relevantDepartment,relevantSchool,otherLink]
    const lis = this.$el.find(".footer-header-ul>li");
    if(lis.length>0){
      $.each(lis,(index,item)=>{
        const web = webArr[index];
        let htmlTemp = "<div  class='webList'><ul>";
        for (var i = 0; i < web.length; i++) {
            htmlTemp += "<li><a href="+ web[i].url + " target='_blank'>" + web[i].name + "</a></li>";
        }
        htmlTemp += "</ul></div>";
        $(item).append($(htmlTemp))
      })
    }
  }

}
module.exports = univFooter;
